import { render } from "./ArticleCategoryModal.vue?vue&type=template&id=ba62a9b4"
import script from "./ArticleCategoryModal.vue?vue&type=script&lang=js"
export * from "./ArticleCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__